// removed by extract-text-webpack-plugin
module.exports = {"row":"_33H-yjERkWguqfIf3srAyH","buttonRow":"_3fDJ80YtWYB3HnPVUlAIPz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DebtPhaseExpenses/styles.css
// module id = 501
// module chunks = 0